module.exports = __webpack_public_path__ + "img/about-fs.e474de9f.jpg";